export enum ACTION_ITEM_STATUS {
  TO_DO = 'ToDo',
  IN_PROGRESS = 'InProgress',
  COMPLETED = 'Completed',
}

// Class names below are existing @theme tokens from src/index.css (Tailwind
// class suffixes, e.g. `bg-accepted`). SH1-04 measured all three states
// directly against the Figma export nodes (7362-183241, 8680-112883,
// 8680-114161) with getComputedStyle — see SH1-04's progress.txt entry for
// the exact hex→token derivation. `inReview_10` / `completed_10` are new
// @theme tokens (src/index.css) added this story: the existing `inReview_bg`/
// `completed_bg` tokens are different rgb values (used elsewhere — claim
// banners, fabricator-dashboard alert — so not safe to repurpose), and
// Tailwind v4's `/10` opacity modifier serializes as oklab() via color-mix,
// not a directly comparable rgb — literal tokens keep getComputedStyle
// assertions exact. Naming follows the existing `{color}_{alphaPercent}`
// convention already used for greenDark_60/greyDark_60/etc.
export const ACTION_ITEM_STATUS_META: Record<
  ACTION_ITEM_STATUS,
  { label: string; bgClassName: string; textClassName: string }
> = {
  [ACTION_ITEM_STATUS.TO_DO]: {
    label: 'To do',
    bgClassName: 'bg-newClaim_bg',
    textClassName: 'text-newClaim',
  },
  [ACTION_ITEM_STATUS.IN_PROGRESS]: {
    label: 'In progress',
    bgClassName: 'bg-inReview_10',
    textClassName: 'text-inReview',
  },
  [ACTION_ITEM_STATUS.COMPLETED]: {
    label: 'Completed',
    bgClassName: 'bg-completed_10',
    textClassName: 'text-completed',
  },
};
